export default __webpack_public_path__ + "static/media/childDevelopmnet-blob5.68529518.svg";